export default function isMainshop(shopId) {
    return (shopId.match(/-/g) || []).length <= 1;
}



// WEBPACK FOOTER //
// ../ui-components/mainDealerFilter.js